import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss'
})
export class SearchComponent implements OnInit, OnDestroy {
  @Input() placeholder: string = 'Search drivers';
  @Input() disabled: boolean = false;
  @Input() customWidth: string = '250px';
  @Input() searchTerm: string;

  @Output() searchTermUpdated: EventEmitter<string> = new EventEmitter<string>();

  private searchSubscription: Subscription;
  private searchTermSubject = new Subject<string>();

  ngOnInit(): void {
    this.subscribeToSearch();
  }

  ngOnDestroy(): void {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }

  onSearchTermChange(event: string): void {
    this.searchTermSubject.next(event);
  }

  private subscribeToSearch(): void {
    this.searchSubscription = this.searchTermSubject
      .pipe(
        debounceTime(1000),
        distinctUntilChanged()
      )
      .subscribe(searchTerm => {
        this.searchTermUpdated.emit(searchTerm)
      });
  }
}
